import React from "react";
import Modal from "../../../shared/components/UI/Modal";
import { UserIcon, EnvelopeIcon, PhoneIcon } from "@heroicons/react/24/outline";
import { useHistory } from "react-router";

/**
 * Small local Tailwind input, scoped to the gift form only — matches the
 * rounded-xl / icon-leading pattern used by Hero.js's search inputs.
 * Not extracted to shared/UI since this is the only consumer.
 */
function GiftField({ icon: Icon, ...props }) {
    return (
        <div className="flex items-center gap-2.5 ps-4 pe-3 h-12 rounded-xl bg-white border border-slate-200 hover:border-slate-300 focus-within:border-brand-500 focus-within:ring-2 focus-within:ring-brand-500/15 transition">
            <Icon className="w-4 h-4 text-ink-subtle shrink-0" />
            <input
                {...props}
                className="flex-1 min-w-0 text-sm font-medium text-ink placeholder:text-ink-subtle bg-transparent outline-none"
            />
        </div>
    );
}

const Gift = ({shown,close,event}) => {

    const history = useHistory();
    const submitAsGift = async ( e ) => {
        e.preventDefault();

        const formData = new FormData(e.target);
        let _formGift = {
            gift_email : formData.get("email") ,
            gift_name  : formData.get("name") ,
            gift_phone : formData.get("phone")
        };

        await localStorage.setItem("gift", JSON.stringify( _formGift ));
        await localStorage.setItem("order", JSON.stringify(event));
        history.push("/booking");

        close();
    }
    return(
        <>
        <Modal
            shown={shown}
            close={close}
            size={"modal--small"}
            title="L'offrir en cadeau"
            subtitle="Des cadeaux inoubliables sans complications. Renseignez les détails de le personne à qui vous souhaiter offrir ce cadeau"
            >
            <form method="POST" onSubmit={ submitAsGift } className="space-y-3">
                <GiftField
                    icon={UserIcon}
                    placeholder="Nom et Prénom"
                    type="text"
                    name="name"
                    required
                />

                <GiftField
                    icon={EnvelopeIcon}
                    placeholder="E-mail"
                    type="email"
                    name="email"
                    required
                />

                <GiftField
                    icon={PhoneIcon}
                    placeholder="Téléphone"
                    type="text"
                    name="phone"
                    required
                />

                <button
                    type="submit"
                    className="w-full h-12 rounded-xl font-semibold bg-brand-500 text-white hover:bg-brand-600 transition-colors shadow-card flex items-center justify-center gap-2 focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-500/30"
                >
                    Réserver !
                </button>
            </form>
        </Modal>
        </>
    );
};

export default Gift;
